module.exports = __webpack_public_path__ + "files/8d39d36acfc6af8227e4f77302e81a2b.png";